<template lang="pug">
div
  slot(name="title")
  y-dialog(v-model='showPicker' width='400px' persistent content-class="round-3xl")
    template(v-slot:activator='{ on }')
      v-text-field.text-sm.round-xl(v-model="selectedDateField" :placeholder="placeholder" outlined dense :height="height" :rules="required ? rules.not_empty : []" :hide-details="hideDetails" v-on="on" :disabled="disabled" :loading="loading" :background-color="disabled ? 'neutral300' : ''")
        template(v-slot:append)
          eva-icon(:class="{ 'mt-1' :height === '48' }" name="calendar-outline" fill="#848484")
    v-card
      v-card-text.px-2.pt-2.pb-0
        div.d-flex.justify-center.align-center(v-if="loading" style="height: 380px;")
          v-progress-circular(:width="2" :size="50" color="primary" indeterminate)
        yc-date-picker(v-else :parentDate.sync="selectedDate" :allowedDates="unavailableDateList" :minDate="minDate" :parentPickerDate.sync="compPickerDate")
      v-card-actions.px-4.pb-4
        v-row(no-gutters)
          v-col.pr-2
            v-btn.button-sm(color="neutral700" block dark outlined depressed @click="closeDate") {{ $t('cancel') }}
          v-col.pl-2
            v-btn.button-sm(color="neutral700" block depressed :dark="Boolean(selectedDate)" :disabled="!selectedDate" @click="pickDate(selectedDate); setLater = false") {{ $t('select') }}
  div.mt-3(v-if="showSetLater")
    y-checkbox(v-model="setLater" :disabled="disabled")
      template(#label)
        .text-sm.neutral700--text Set this later
</template>

<script>
import { DateTime } from 'luxon'

export default {
  props: {
    value: {
      type: String,
      default: null,
    },
    loading: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    placeholder: {
      type: String,
      default: null
    },
    hideDetails: {
      type: String,
      default: 'auto'
    },
    height: {
      type: String,
      default: '48'
    },
    pickerDate: {
      type: String,
      default: null
    },
    minDate: {
      type: String,
      default: null
    },
    showSetLater: {
      type: Boolean,
      default: false
    },
    required: {
      type: Boolean,
      default: true
    },
    unavailableDates: {
      type: Array,
      default: (() => [])
    },
    isSetLater: {
      type: Boolean,
      default: false
    },
    setLaterTodayDate: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      showPicker: false,
      selectedDate: null,
      selectedDateField: null,
      rules: {
        not_empty: [val => (val || '').length > 0 || 'This field is required'],
      },
    }
  },
  computed: {
    setLater: {
      get () {
        return this.isSetLater
      },
      set (val) {
        this.$emit('update:isSetLater', val)
        if (val) {
          if (this.setLaterTodayDate) {
            this.pickDate(this.todayDate())
          } else {
            this.selectedDateField = null
            this.$emit('input', null)
            this.$emit('change', null)
          }
        }
      }
    },
    compPickerDate: {
      get () {
        return this.pickerDate
      },
      set (val) {
        this.$emit('update:pickerDate', val)
      }
    },
  },
  watch: {
    value: {
      immediate: true,
      handler (val) {
        if (val) {
          this.selectedDate = val
          this.selectedDateField = this.$options.filters.humanizeDate(val)
        } else {
          this.selectedDate = null
          this.selectedDateField = null
        }
      }
    }
  },
  methods: {
    unavailableDateList (val) {
      if (this.unavailableDates.includes(val)) {
        return false
      }
      return true
    },
    pickDate (date) {
      this.selectedDateField = this.$options.filters.humanizeDate(date)
      this.showPicker = false
      this.$emit('input', date)
      this.$emit('change', date)
    },
    closeDate () {
      this.showPicker = false
    },
    todayDate () {
      return DateTime.local().toFormat('yyyy-MM-dd')
    }
  }
}
</script>

<style lang="scss" scoped>

</style>